K<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import Store from '@/store'
import { TweenMax as Tween, TimelineMax as Line, Power1 } from 'gsap'
import TransitionWrapper from '@/layout/wrappers/transition-wrapper'
import ScrollMarker from '@/components/scroll-marker'
import BaseButton from '@/components/base-button'
import List from './list'
import TheFooter from '@/layout/the-footer'

export default {

  name: 'ProjectsPage',

  components: {
    TransitionWrapper,
    ScrollMarker,
    List,
    BaseButton,
    TheFooter
  },

  computed: {
    $content () {
      return this.$store.state.pages.landings.projects
    },

    all () {
      return this.$store.getters['pages/all']('projects')
    },

    primary () {
      return this.$store.getters['pages/primary']('projects')
    },

    items () {
      return this.$store.getters['pages/items']('projects');
    },

    count () {
      return parseInt(this.$content.count);
    },

    lang () {
      return this.$route.params.lang
        ? this.$route.params.lang
        : 'ua'
    }
  },

  beforeRouteEnter: async (to, from, next) => {
    Store.commit('startLoading');

    const page = await Store.dispatch('pages/fetchLanding', 'projects');
    const items = await Store.dispatch('pages/fetchDynamic', {
      name: 'projects',
      limit: 7,
      offset:0,
      firstLoad: true
    });

    Store.commit('endLoading');

    const errors = [];

    if (items.length <= 0) errors.push('Projects page must have at least one project.');


    if (errors.length > 0) {

      next({
        path: '/' + (from.params.lang || 'ua') + '/error',
        query: { code: 500, errors }
      })
      return
    }

    next()
  },

  beforeRouteUpdate: async (to, from, next) => {
    if (from.params.lang === to.params.lang) {
      next()
      return
    }

    Store.commit('startLoading')

    const page = await Store.dispatch('pages/fetchLanding', 'projects')
    const items = await Store.dispatch('pages/fetchDynamic', {
      name: 'projects',
      limit: 7,
      offset:0,
      firstLoad: true
    })

    Store.commit('endLoading')

    const errors = [];

    console.log(errors);

    if (items.length <= 0) errors.push('Projects page must have at least one project.')

    if (errors.length > 0) {

      next({
        path: '/' + (from.params.lang || 'ua') + '/error',
        query: { code: 500, errors }
      })
      return
    }

    next()
  },

  created(){
    this.setTitle();
  },

  methods: {

    setTitle(){
      let title = document.getElementsByTagName('title')[0];
      return title.text = this.$content.meta.title;
    },

    loadMore () {
      const lastItem = this.items[this.items.length - 1];

      this.$store.dispatch('pages/fetchDynamic', {
        name: 'projects',
        limit: 7,
        offset:this.items.length+1
      })
    },

    getBackgroundImage (item) {
      if (item.media && item.media.image) {
        return `background-image: url(${item.media.image.url})`
      } else {
        return `background-image: url(/public/images/project-cover.jpg)`
      }
    },

    enter () {
      const tl = new Line()
      const els = [
        this.$refs.cat,
        this.$refs.title,
        this.$refs.button.$el
      ]

      tl.staggerFrom(els, 1, {
        autoAlpha: 0,
        y: -40,
        ease: Power1.easeOut
      }, 0.1)

      tl.from(this.$refs.thumb, 1, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        // onUpdate: () => {
        //   if (!this.$refs.thumb) return

        //   const x = this.$refs.thumb.style.opacity * 100

        //   Tween.set(this.$refs.thumb, {
        //     clipPath: `polygon(0% 0%, ${x}% 0%, ${x}% 100%, 0% 100%)`
        //   })
        // }
      }, 0.2)
    },

    leave (el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done()
      } else {
        Tween.to(el, 0.5, {
          autoAlpha: 0,
          ease: Power1.easeOut,
          onComplete: done
        })
      }
    },

    scroll () {
      const bb = this.$refs.list.$el.getBoundingClientRect()
      const scroll = this.$store.state.app.window.scroll + bb.top

      Tween.to(window, 1, {
        scrollTo: scroll,
        ease: Power1.easeInOut
      })
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.projects-page

  .project
    router-link.project-container(:to="'/' + lang + '/projects' + primary.url")
      .project-content
        .project-content__info
          .project-content__category(ref="cat") {{ primary.cat }}
          .project-content__title(ref="title") {{ primary.title || 'Project title' }}
        base-button.project-content__button(:url="'/' + lang + '/projects' + primary.url", :label="$t('open-case')" ref="button")

      .project-thumb(:style="getBackgroundImage(primary)" ref="thumb")

    transition-wrapper(:appear="true")
      scroll-marker.project-scroll(@click="scroll", :dark-mode="true", :label="$t('more-cases')")

  transition-wrapper(:appear="true")
    list(type="projects", :items="items", :count="count - 1" ref="list", @load-more-items="loadMore")

  the-footer

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.project
  position relative
  display flex
  justify-content center
  padding-top 205px
  padding-bottom 190px

  +tablet()
    padding-top 170px

  +mobile()
    padding-top 115px
    padding-bottom: 120px;

.project-container
  display flex
  justify-content space-between
  align-items center
  width 100%
  max-width 1188px
  padding 0 90px

  +above(1024px)
      &:hover
        .project-content__title
          text-decoration underline
          text-decoration-color orange

        .project-thumb
          opacity 0.45 !important

  +hd()
    max-width 1260px
    padding 0

  +below(1023px)
    flex-direction column-reverse

  +mobile()
    max-width 636px

  +mobile()
    padding 0

.project-content
  display flex
  flex-direction column
  justify-content space-between

  +hd()
    width 420px

  +above(1024px)
    margin-right 45px
    width 357px
    padding-top 15px
    padding-bottom 15px

  +below(1023px)
    align-self flex-start
    padding 0 10px

  +mobile()
    padding 0 23px

  &__info
    display flex
    flex-direction column

    & + *
      margin-top 75px

      +below(1023px)
        margin-top 34px

  &__category
    font-weight 500
    font-size 12px
    color blue

    & + *
      margin-top 20px

  &__title
    font-weight 500
    font-size 56px
    line-height 57px
    margin-left -2px

    +hd()
      font-size 76px
      line-height 76px

    +tablet()
      font-size 46px
      line-height 50px

    +mobile()
      font-size 37px
      line-height 37px

  &__button
    align-self flex-start

.project-thumb
  width 608px
  max-width 61%
  height 376px
  max-height 32vw
  background-size cover
  background-position center
  background-repeat no-repeat
  transition opacity .3s

  +hd()
    width 721px
    height 445px

  +below(1023px)
    width 100%
    max-width 100%
    max-height none

  +tablet()
    margin-bottom 50px
    height calc((100vw - 180px) * .62)

  +mobile()
    margin-bottom 35px
    height 363px
    max-height calc(100vw * .62)


.project-scroll
  position absolute
  left 0
  right 0
  bottom 0
  margin 0 auto

</style>



// WEBPACK FOOTER //
// projects.vue?2f9965cc